import { env } from '../env';

export function capterraHandler() {
	if (env.capterraVid && env.capterraVkey) {
		var ct = document.createElement('img');
		ct.src = 'https://ct.capterra.com/capterra_tracker.gif?vid=' + env.capterraVid + '&vkey=' + env.capterraVkey;
		document.body.appendChild(ct);
	}
}
